module.exports = __webpack_public_path__ + "img/shandong.2209b772.jpg";